import states from "assets/stateCodes.json";
import moment from "moment";
import * as yup from "yup";

const formatTimeForField = (timePart) => {
  if (timePart) {
    return moment(`${new Date().toISOString().split("T")[0]}T${timePart}`);
  }
  return timePart;
};

export const primaryCompanyAISettingsSchema = yup.object().shape({
  aiSettings: yup.object({
    interviewAutoSchedulingMinAvailabilityTime: yup.string().test({
      name: "validTimes",
      test: (value, ctx) => {
        const defaultMinAvailabilityTime = moment()
          .set("hours", 6)
          .set("minutes", 0)
          .set("seconds", 0)
          .set("milliseconds", 0);
        const defaultMaxAvailabilityTime = moment()
          .set("hours", 21)
          .set("minutes", 0)
          .set("seconds", 0)
          .set("milliseconds", 0);

        const maxTime = ctx?.parent?.interviewAutoSchedulingMaxAvailabilityTime
          ? formatTimeForField(ctx?.parent?.interviewAutoSchedulingMaxAvailabilityTime) ||
            defaultMaxAvailabilityTime
          : defaultMaxAvailabilityTime;
        const minTime = value
          ? formatTimeForField(value) || defaultMinAvailabilityTime
          : defaultMinAvailabilityTime;
        const minTimeHoursString = minTime.format().split("T")[1];
        const maxTimeHoursString = maxTime.format().split("T")[1];

        if (maxTimeHoursString <= minTimeHoursString) {
          return ctx.createError({ message: "Max Time must be greater than Min Time" });
        }
        return true;
      },
    }),
  }),
});
